import { Box, Chip } from "@outschool/backpack";
import { getFundingProgramProperties } from "@outschool/funding-programs-shared";
import {
  ClassDetailsNoSectionsQuery,
  EsaStatus
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";
import React from "react";

export const EsaEligibleChips = ({
  activity
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
}) => {
  const esaState = useFundingProgramAbbr();
  const { currentUser } = useSession();

  const approvedFundingPrograms = activity.userApprovedFundingPrograms;
  const esaStatus = activity.esaStatus;

  if (!!currentUser?.hasEsaMembership && !!approvedFundingPrograms) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "1em"
        }}
      >
        {approvedFundingPrograms.map(fundingProgram => {
          return (
            <FundingProgramEligibleChip
              fundingProgram={fundingProgram}
              key={fundingProgram}
            />
          );
        })}
      </Box>
    );
  } else if (
    !currentUser?.hasEsaMembership &&
    esaStatus === EsaStatus.Approved &&
    !!esaState
  ) {
    return <FundingProgramEligibleChip fundingProgram={esaState} />;
  }

  return <></>;
};

const FundingProgramEligibleChip = ({
  fundingProgram
}: {
  fundingProgram: string;
}) => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\subcomponents\\EsaEligibleChips"
  );

  const fundingProgramProperties = getFundingProgramProperties(fundingProgram);
  if (!fundingProgramProperties) {
    return null;
  }

  return (
    <Box>
      <Chip
        size="small"
        sx={{
          backgroundColor: "success.light",
          color: "success.dark"
        }}
        label={t("{{fundingProgram}} approved", {
          fundingProgram: fundingProgramProperties?.programName
        })}
      />
    </Box>
  );
};
